{
	"title": "Projekt",
	"table": {
		"reference": "Referens",
		"quantity": "Total kvantitet",
		"savings": "Totala koldioxidreduktioner",
		"fetchError": "Det gick inte att hämta projekt"
	},
	"showProjectsHistoryTitle": "Visa projekthistorik",
	"noProjects": {
		"createDeclaration": "Skapa din första deklaration",
		"description": "Du kan skapa deklarationer för ett eller flera material genom att klicka på ”Skapa deklaration”."
	}
}
